import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=20b1829e&lang=pug&"
import script from "./InvoiceList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceList.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=20b1829e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports